export enum TeamStatus {
	Active,
	Expired,

	Archived,
	Deleted,
}
